import React, { useState } from 'react';
import IntakeForm from './components/IntakeForm';
import ReportView from './components/ReportView';

const initialFormState = {
  companyName: '', industry: '', employeeCount: '', primaryContact: '',
  q1: '', q2: '', q3: '', q4: '', q5: '', q6: '',
  q7: '', q8: '', q9: '', q10: '', q11: '', q12: ''
};

function App() {
  const [view, setView] = useState('form');
  const [formData, setFormData] = useState(initialFormState);

  const handleGenerateReport = (data) => {
    setFormData(data);
    setView('report');
    window.scrollTo(0, 0);
  };

  return (
    <div className="font-sans text-veit-gray bg-veit-light min-h-screen">
      {view === 'form' 
        ? <IntakeForm initialData={formData} onGenerate={handleGenerateReport} /> 
        : <ReportView data={formData} onBack={() => setView('form')} />}
    </div>
  );
}

export default App;